module.exports = __webpack_public_path__ + "img/ic_premium_check.9fd5e1b5.svg";